import Upload from './Upload';
import Dragger from './Dragger';
import "antd/lib/upload/style";

export { UploadProps, UploadListProps, UploadChangeParam, RcFile } from './interface';
export { DraggerProps } from './Dragger';

Upload.Dragger = Dragger;
export default Upload;


// WEBPACK FOOTER //
// ./src/components/upload/index.tsx